import PropTypes from 'prop-types';
import React from 'react';
import StyledButton from './styled-button';

const sizes = ['large', 'medium', 'small'];

const propTypes = {
	children: PropTypes.node,
	dataTestId: PropTypes.string,
	icon: PropTypes.element,
	iconRight: PropTypes.bool,
	fullWidth: PropTypes.bool,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(sizes),
		PropTypes.shape(
			['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].reduce(
				(acc, current) => ({ ...acc, [current]: PropTypes.oneOf(sizes) }),
				{},
			),
		),
	]),
	variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
};

const defaultProps = {
	children: null,
	dataTestId: null,
	fullWidth: false,
	icon: undefined,
	iconRight: false,
	size: 'large',
	variant: 'primary',
};

function SpanButton({ dataTestId, ...props }) {
	return (
		<StyledButton className="fuse-span-button" data-testid={dataTestId} {...props} as="span" />
	);
}

SpanButton.propTypes = propTypes;
SpanButton.defaultProps = defaultProps;

export default SpanButton;
